import type { MenuProps } from '@mui/material';
import type { MouseEvent } from 'react';

/**
 * Menu props for a Select. The menu is portaled, but React still bubbles
 * its clicks and mouse presses to the Select's ancestors, so the menu stops
 * them: a choice in the menu does not reach a handler of the host that
 * holds the Select. It opens below the field from the field's left edge,
 * and it caps its height at `maxHeight` px.
 */
export function selectMenuProps(maxHeight: number): Partial<MenuProps> {
    return {
        disablePortal: false,
        disableScrollLock: true,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        onClick: (e: MouseEvent) => e.stopPropagation(),
        onMouseDown: (e: MouseEvent) => e.stopPropagation(),
        slotProps: { paper: { sx: { maxHeight, zIndex: 1500 } } },
    };
}

export const menuProps = selectMenuProps(200);
